

























import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { getDateTimeStamp, setDateTimeStamp } from '@acgn/herm/src/util/time';
import { AttributeMixin, RenderMenuMixin } from '@/mixins';
import { SearchMixin } from '@acgn/herm/src/mixins';
import { Tooltip } from 'element-ui';

import {
  AcgnSearchWrap,
  AcgnTable,
  AcgnTableButtonGroup,
  AcgnTopButton,
} from '@acgn/herm/src/ui';
import { displayFormValidationError } from '@acgn/herm/src/util/form';
import event from '@acgn/herm/src/util/event';

const RoleAction = namespace('desk/role').Action;

const RoleGetter = namespace('desk/role').Getter;

interface SearchType { // 搜索
  group_id: number; // 当前页码
  searchVal?: string; // 角色名称
  page?: number; // 当前页码
}

interface PopTargetData { // 收费弹窗
  visible: boolean; // 是否显示
  data: any; // 弹窗交互数据
}

// 组件申明
@Component({
  components: {
    AcgnSearchWrap,
    AcgnTable,
    AcgnTopButton,
    [Tooltip.name]: Tooltip
  },
  mixins: [AttributeMixin, SearchMixin, RenderMenuMixin]
})
export default class RoleList extends Vue {

  @RoleAction private getRoleList: any; // 获取角色列表
  @RoleAction private getRoleGroupList: any; // 获取角色组列表

  @RoleGetter private roleList: any; // 角色列表
  @RoleGetter private loadings: any; // 角色loading

  private searchForm: SearchType = { // 头部筛选项
    group_id: 0,
    searchVal: '',
    page: 1
  };
  private roleGroupList = []; // 角色组
  private selectRoleGroup: any = {}; // 选中的角色组
  private pageConfig: any = { // 分页数据
    total: 0,
    currentPage: 1
  };

  // 列表配置
  private tableConfig: any = {
    rowClassName: ({ row }: any) => {
      return `page-table-row ${row.state === 2 ? 'color--danger' : ''}`;
    },
    columns: [
      {
        label: '角色名称',
        prop: 'dtalk_role_name',
        width: 100
      },
      {
        label: '页面权限',
        prop: 'permission',
        showOverflowTooltip: false,
        render: (h: any, { row }: any) => (this as any).renderPermission(row)
      },
      {
        label: '操作',
        prop: 'action',
        width: 100,
        fixed: 'right',
        showOverflowTooltip: false,
        render: (h: any, { row, $index }: any) => {
          const btns = [
            {
              icon: 'ift-chapter',
              color: '#73c800',
              text: '修改权限',
              type: 'edit',
              disabled: false,
              to: {
                name: 'desk-roleEdit',
                params: {
                  id: row.id
                }
              },
              permission: ['4003']
            }
          ];
          btns.forEach((btn: any) => {
            btn.row = row;
          });
          return h(AcgnTableButtonGroup, {
            props: {
              btns,
            },
            on: {
              click: (item: any) => {
                this.onListAction(item);
              },
            },
          });
        }
      }
    ],
    data: []
  };

  private async created() {
    this.roleGroupList = (await this.getRoleGroupList()).result;
    const cacheForm: any = this.$getFormCache();
    this.searchForm = { ...this.searchForm, ...cacheForm };
    if (this.searchForm.page) { // 如果有缓存页码，先赋值
      this.pageConfig.currentPage = this.searchForm.page;
    }
    let group: any = this.roleGroupList[0];
    if (this.searchForm.group_id) {
      group = this.roleGroupList.find((item: any) => item.id === this.searchForm.group_id);
    }
    this.selectRoleGroup = group;
    this.search();
  }

  private renderPermission(row: any) {
    const arr: any = [];
    row.permissions.map((item: any) => {
      arr.push(item.permission_name);
    });
    const content = arr.join(',');
    return (
      <el-tooltip content={content} placement="top" popper-class="role-list-pop">
        <div class="text-ellipsis">{content}</div>
      </el-tooltip>
    );
  }

  // 列表操作项
  private onListAction(item: any) {

  }

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <div class="acgn-side-box__menu">
        <div class="menu-title">角色组</div>
        <ul class="menu-status-list expand">
          {
            this.roleGroupList.map((item: any) => {
              return (
                <li
                  class={['menu-status-item', { selected: this.selectRoleGroup.id === item.id }]}
                  onClick={() => this.selectCliGroup(item)}
                >
                  <div class="item-left">
                    <span>{item.dtalk_role_name}</span>
                  </div>
                </li>
              );
            })
          }
        </ul>
      </ div>
    );
  }

  // 选择
  private selectCliGroup(item: any) {
    if (this.selectRoleGroup.id === item.id) {
      return;
    }
    this.selectRoleGroup = item;
    this.search();
  }

  // 刷新当前页
  private reloadList() {
    this.initSearh({ page: this.pageConfig.currentPage });
  }

  // 搜索
  private search() {
    this.initSearh({ page: 1 });
  }

  // table组件获取数据更新数据接口
  private async initSearh({ page }: { page: any }) {
    if (!this.selectRoleGroup.id) {
      return;
    }
    const { tableConfig, pageConfig } = this;
    const options = {
      ...filterEmpty(this.searchForm),
      page,
      size: 30,
      group_id: this.selectRoleGroup.id
    };
    await this.getRoleList(options);
    const { result, paging } = this.roleList;
    tableConfig.data = result.items;
    pageConfig.currentPage = paging.page;
    pageConfig.pageSize = paging.size;
    pageConfig.total = paging.total;

    const { size, ...args } = options;
    this.$setFormCache({ ...args });
  }
}
